import Vue from 'vue/dist/vue.js';

const retailerMap = Vue.component('retailer-list-item',
    {
        delimiters: ['@{','}'],

        template: `<div >
                    <a @click="toggle()" class="departments__list-item-link" :class="{ 'departments__list-item-link--active': isActive }">
                        <span class="find-department__list-small" v-if="retailer.distance">@{retailer.distance | km}  km unna</span>
                        <span>@{ retailer.location }</span>
                    </a>
                    <div v-show="isActive" :class="{ 'departments__details--active': isActive }">
                        <ul class="departments__details-list">
                            <li class="departments__details-list-item">@{ retailer.address }</li>
                            <li class="departments__details-list-item">@{ retailer.zipcode } @{ retailer.city }</li>
                            <li class="departments__details-list-item">
                                <a class="departments__details-list-item--link" :href="'tel:' + retailer.phone" @click="handlePhone($event, retailer.phone)">Vis telefonnr.</a>
                                <a class="departments__details-list-item--link" :href="'mailto:' + retailer.email">send epost</a>
                            </li>
                            <li class="departments__details-list-item" v-if="retailer.brands && retailer.brands.length">
                                <strong>Vi har: </strong>
                                <span  class="brand-tag" v-for="brand in retailer.brands">@{brand.name}</span>
                            </li>
                            <li class="departments__details-list-item">
                                <div class="departments__c2a">
                                    <a :href="retailer.url" class="btn btn__link btn--primary">Gå til forhandler</a>
                                </div>
                            </li>
                        </ul>
                        <div class="retailer-map" data-map v-if="isActive">
                            <retailer-map :retailer="retailer"></retailer-map>
                        </div>
                    </div>
                </div>`,

        props : [ 'retailer'],

        filters:
        {
            km(value)
            {
                return parseInt(value);
            }
        },

        data: function()
        {
            return {
                isActive: false
            }
        },

        created ()
        {
            // console.log('retailer list item created');
        },

        methods:
        {
            toggle()
            {
                this.isActive = !this.isActive;
            },

            handlePhone(event) {
                if (event.target.innerText === 'Vis telefonnr.') {
                    event.preventDefault();
                }
                event.target.innerText = event.target.href.replace('tel:', '');
            }
        },

});

export default retailerMap;